import React, { createContext, useContext, useState } from "react";
const context = createContext(undefined);
export function UseQuickPayProvider(props) {
    const [token, setToken] = useState(null);
    const [quickPayOnly, setQuickPayOnly] = useState(false);
    return (<context.Provider value={{ token, setToken, quickPayOnly, setQuickPayOnly }}>
			{props.children}
		</context.Provider>);
}
export default function useQuickPayContext() {
    const hContext = useContext(context);
    if (!hContext) {
        return {
            token: null,
            setToken: () => null,
            quickPayOnly: false,
            setQuickPayOnly: () => null
        };
    }
    return hContext;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/QuickPay/useQuickPayContext.tsx